<div style="padding-bottom: 2rem;">

  @if (profile) {
    <app-my-assessments [profile]="profile"></app-my-assessments>

    <div class="h-divider"></div>

    <app-team-assessments [profile]="profile"></app-team-assessments>
  }
</div>